import React from 'react';
import PropTypes from "prop-types";
import Button from '../../components/Button';
import Api, {Utils} from '../../Api';

export default class AdminProductOptionEdit extends React.Component {
  componentWillMount() {
    let productToken = this.props.params.productId;
    let optionToken = this.props.params.optionId;

    Utils.bindThis(
        this,
        [
          'goBack',
          'cancelButton',
          'saveButton'
        ]
    );

    let defaultOption = null;

    if (!optionToken) {
      defaultOption = {
        name: '',
        brand_code: '',
        description: '',
        group_name: '',
        parent_token: '',
        images: []
      };
    }

    let self = this;

    Api.getProductCache(productToken)
        .then(
            (response) => {
              let product = response.products[productToken];
              self.setState({product});
            }, (error) => {
              console.error(error)
            }
        );

    Api.getProductOption(productToken, optionToken)
        .then(
            (option) => {
              self.setState({
                loading: false,
                option: option
              });
            },
            (err) => {
              self.setState({
                loading: false,
              });
            }
        );

    this.state = {
      loading: (defaultOption == null),
      product: null,
      option: defaultOption
    };
  }

  goBack() {
    this.context.router.goBack();
  }

  cancelButton() {
    // TODO: ask if we're sure to cancel if there are any changes.
    this.goBack();
  }

  saveButton() {
    let payload = Utils.getFormValues(
        this,
        [
          'name',
          'brand_code',
          'description',
          'group_name',
          'parent_token'
        ]
    );

    if (this.props.params.optionId) {
      payload.token = this.props.params.optionId;
    }

    payload.group_name = payload.group_name ? payload.group_name : '';

    // Images
    let imageValues = this.refs.urls.value;
    if (imageValues && imageValues.length > 0) {
      payload.images = imageValues.split('\n').map((url) => {
        return ({url: url});
      });
    }

    let ret = Api.saveProductOption(this.state.product.token, payload);
    ret.then(this.goBack);

    return (ret);
  }

  render() {
    if (this.state.loading) {
      return (<div>loading...</div>);
    }

    if (this.state.option === null) {
      return (<div>invalid option!</div>)
    }

    let option = this.state.option;

    let selectOptions = [];
    selectOptions.push(<option key="empty-parent-token" value="">-</option>);
    if (this.state.product) {
      (this.state.product.options || [])
          .filter((option) => {
            return (option.token !== this.props.params.optionId)
          })
          .forEach((option) => {
            selectOptions.push(<option key={option.token}
                                       value={option.token}>{option.group_name}: {option.name}</option>);
          });
    }

    let imageUrls = [];
    if (option.images && option.images.length > 0) {
      option.images.forEach((image) => {
        imageUrls.push(image.url);
      });
    }

    return (
        <div className="options-editor">
          <div>Options Editor</div>
          <form className="admin-form">
            <div className="form-group">
              <label>Group name (Optional)</label>
              <input className="input" ref="group_name" defaultValue={option.group_name}
                     placeholder="Optional Group Name (e.g., Color)"/>
            </div>
            <div className="form-group">
              <label>Option name (Optional)</label>
              <input className="input" ref="name" defaultValue={option.name || 'default'}
                     placeholder="Optional Name (e.g., Blue)"/>
            </div>
            <div className="form-group">
              <label>SKU # (Optional)</label>
              <input className="input" ref="brand_code" defaultValue={option.brand_code} placeholder="SKU#"/>
            </div>
            <div className="form-group">
              <label>Parent Option (Optional)</label>
              <div className="form-combobox">
                <select ref="parent_token" defaultValue={option.parent_token || ''}>
                  {selectOptions}
                </select>
              </div>
            </div>
            <div className="form-textarea">
              <textarea ref="urls" placeholder="image urls" defaultValue={imageUrls.join('\n')}/>
            </div>
            <div>
              <Button onClick={this.cancelButton}>Cancel</Button>
              <Button onClick={this.saveButton}>Save</Button>
            </div>
          </form>
        </div>
    );
  }
}

AdminProductOptionEdit.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminProductOptionEdit.jsx
 **/